<template>
  <div>
    <div class="text-xl 2xl:text-2xl font-title font-semibold text-ocean-900">
      Concerned with {{ post.title }}?
    </div>
    <hr class="my-4 w-full border-top border-[#CEDFF1]" />
    <div class="vetster-prose text-neutral-900 mt-2">
      <p>Chat with our licensed vet techs in the app to learn more and have your questions answered.</p>
    </div>
    <vetster-livechat-c-t-a class="w-full">
      <template #store-icons>
        <div class="mt-6 flex justify-center-items-center">
          <div class="flex flex-1 flex-col space-y-2 w-full justify-center items-center sm:items-end pr-1">
            <vetster-mobile-app-buttons
              class="flex flex-1 flex-col space-y-2 w-full justify-center items-center sm:items-end pr-1"
              button-size="w-32"
              :apple-app-store-url="mobileApps.apple.url"
              :google-play-url="mobileApps.google.url"
            />
          </div>
          <div class="hidden sm:flex sm:flex-1 sm:pl-2">
            <img
              src="https://images.vetster.com/photos/livechat_qr_code.jpeg?ik-s=81d9166c8b7f0c8b03a8536700afdd184aaf5cc0"
              :alt="$t('app.mobile-app.livechat-qr-code')"
              class="size-24"
            >
          </div>
        </div>
      </template>
    </vetster-livechat-c-t-a>
  </div>
</template>

<script>
import VetsterLivechatCTA from '@/components/VetsterLivechatCTA';
import VetsterMobileAppButtons from '@/components/VetsterMobileAppButtons';

export default {
  name: 'VetsterEditorialModuleConcernWith',

  components: {
    VetsterLivechatCTA,
    VetsterMobileAppButtons,
  },

  props: {
    mobileApps: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
};
</script>
